const translations = {
  newTab: 'Nova aba',
  filter: 'Filtrar',
  addWidget: 'Adicionar Widget',
  closeEdit: 'Fechar edição',
  welcome: 'Boas-vindas, {{name}}!',
  welcomeMessage: 'Veja o que temos preparado para você hoje.',
  dashboardTitle: 'Dashboard',
  'defaultTabs.productivity': 'Produtividade',
  'defaultTabs.ranking': 'Ranking',
  'defaultTabs.efficiency': 'Eficiência',
  'defaultTabs.volumeByStatus': 'Volume de atividades por status',
  'removeScreen.confirm': 'Certeza que deseja remover?',
  'removeScreen.success': 'Tela removida com sucesso!',
  'removeScreen.error': 'Ocorreu um erro ao remover!'
}

export default translations
